export const config = {
  // Server-only credentials — NEVER read these via NEXT_PUBLIC_*: those are
  // inlined into the public client JS bundle, which leaked the notification
  // API key to anyone who downloaded the deployed bundle.
  notificationApiUrl: process.env.NOTIFICATION_API_URL || '',
  notificationApiKey: process.env.NOTIFICATION_API_KEY || '',
  flowApiUrl: process.env.FLOW_API_URL || '',
  flowApiKey: process.env.FLOW_API_KEY || '',
};

export const featureFlags = {
  // Feature flag para habilitar/desabilitar a página de welcome/onboarding
  // Para ativar, defina NEXT_PUBLIC_ENABLE_WELCOME_PAGE=true
  enableWelcomePage: true,
};
